import { useGet, UseGetReturnType } from '../../../../api';
import { USER_MANAGEMENT_BASE_URL } from '../consts';

type ReturnType = Omit<UseGetReturnType<unknown>, 'data'> & {
    domains?: string[];
};

export const useGetDomains = (): ReturnType => {
    const { data: domains, ...restValues } = useGet<string[]>({ url: `${USER_MANAGEMENT_BASE_URL}/domains` });

    return {
        ...restValues,
        domains
    };
};
